export default {
  getCategory: (state) => {
    return state.category
  },
  getCheckout: (state) => {
    return state.checkout
  },
  getProject: (state) => {
    return state.project
  },
  getRelease: (state) => {
    return state.release
  },
  getOngoing (state, payload) {
    return state.going
  },
  getClosed (state, payload) {
    return state.closed
  },
  // 终端人的项目管理
  getProjectManagement (state, payload) {
    return state.projectManagement
  }
}
